import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@/icons";

import {
    Input,
    Button,
    Radio,
    RadioGroup,
    Dialog,
    Form,
    FormItem,
    Table,
    TableColumn,
    Pagination,
    Loading,
    MessageBox,
    Message,
    Notification,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Option,
    OptionGroup,
    DatePicker,
    Select,
    Row,
    Col,
    Upload,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Progress,
} from "element-ui";

import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

Vue.component(Input.name, Input);
Vue.component(Button.name, Button);
Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Dialog.name, Dialog);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Pagination.name, Pagination);
Vue.use(Loading.directive);
Vue.component(MessageBox.name, MessageBox);
Vue.component(Message.name, Message);
Vue.component(Notification.name, Notification);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.component(Option.name, Option);
Vue.component(OptionGroup.name, OptionGroup);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Select.name, Select);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Upload.name, Upload);
Vue.component(Checkbox.name, Checkbox);
Vue.component(CheckboxButton.name, CheckboxButton);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Progress.name,Progress)

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

import "swiper/swiper-bundle.css";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import {
    Swiper as SwiperClass,
    Pagination as SwiperPagination,
    Navigation,
    Autoplay,
} from "swiper/core";
SwiperClass.use([SwiperPagination, Navigation, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));

import HttpConnection from "@/utils/HttpConnection";
import Api from "@/utils/Api";
Vue.prototype.Api = Api;
Vue.prototype.HttpConnection = HttpConnection;

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
